import React from "react";
import Situation from "../../components/common/Situation";

const CustomerSituation = () => {
  return <Situation type={"customer"} />;
};

export default CustomerSituation;
